import React from 'react';
import { useTranslation } from 'react-i18next';
import * as yup from 'yup';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup/dist/yup';
import { Zoom } from '@mui/material';
import { Link } from 'react-router-dom';
import { useContainer } from 'unstated-next';
import Icon from '@mdi/react';
import { mdiCheckCircleOutline } from '@mdi/js';
import { ControlledInput } from '../../components/forms';
import PasswordResetContainer from './PasswordResetContainer';
import {
    ButtonText,
    FormContainer,
    FormFields,
    HelperText,
    Navigation,
    ResetButton,
    StyledFormControl
} from './styles/password-reset';

export interface ForgotPasswordFormProps {

}

const ForgotPasswordForm: React.FC<ForgotPasswordFormProps> = () => {
    const { isLoading, isFinished, requestPasswordReset } = useContainer(PasswordResetContainer);

    const { t } = useTranslation('password_reset');

    const schema = yup.object({
        email: yup.string().email(t('errors.invalid-email')).required(t('errors.invalid-email'))
    });

    const { control, getValues, handleSubmit } = useForm({ resolver: yupResolver(schema) });

    const onSubmit = (data) => {
        requestPasswordReset(data.email);
    };

    const getButtonText = () => {
        if (isFinished) {
            return <ButtonText>{t('email-sent')} <Icon path={mdiCheckCircleOutline} /></ButtonText>;
        }

        return t('reset-your-password');
    };

    const renderFinished = () => {
        if (!isFinished) {
            return (
                <Navigation>
                    <Link to={'/login'}>{t('back-to-sign-in')}</Link>
                </Navigation>
            );
        }

        return (
            <Zoom in={isFinished}>
                <HelperText>
                    {t('email-sent-help', { email: getValues('email') })}
                </HelperText>
            </Zoom>
        );
    };

    return (
        <FormContainer>
            <form onSubmit={handleSubmit(onSubmit)}>
                <FormFields>
                    <StyledFormControl fullWidth>
                        <ControlledInput type="email" name="email" label={t('email')} control={control} />
                    </StyledFormControl>
                </FormFields>
                <ResetButton fullWidth variant={'contained'} type={'submit'} loading={isLoading} disabled={isFinished}>
                    {getButtonText()}
                </ResetButton>
            </form>
            {renderFinished()}
        </FormContainer>
    );
};

export default ForgotPasswordForm;
